"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLitResource = exports.LitActionResource = exports.LitRLIResource = exports.LitPKPResource = exports.LitAccessControlConditionResource = void 0;
const models_1 = require("./models");
class LitResourceBase {
    constructor(resource) {
        this.resource = resource;
    }
    getResourceKey() {
        return `${this.resourcePrefix}://${this.resource}`;
    }
    toString() {
        return this.getResourceKey();
    }
}
class LitAccessControlConditionResource extends LitResourceBase {
    /**
     * Creates a new LitAccessControlConditionResource.
     * @param resource The identifier for the resource. This should be the
     * hashed key value of the access control condition.
     */
    constructor(resource) {
        super(resource);
        this.resourcePrefix = models_1.LitResourcePrefix.AccessControlCondition;
    }
    isValidLitAbility(litAbility) {
        return (litAbility === models_1.LitAbility.AccessControlConditionDecryption ||
            litAbility === models_1.LitAbility.AccessControlConditionSigning);
    }
}
exports.LitAccessControlConditionResource = LitAccessControlConditionResource;
class LitPKPResource extends LitResourceBase {
    /**
     * Creates a new LitPKPResource.
     * @param resource The identifier for the resource. This should be the
     * PKP token ID.
     */
    constructor(resource) {
        super(resource);
        this.resourcePrefix = models_1.LitResourcePrefix.PKP;
    }
    isValidLitAbility(litAbility) {
        return litAbility === models_1.LitAbility.PKPSigning;
    }
}
exports.LitPKPResource = LitPKPResource;
class LitRLIResource extends LitResourceBase {
    /**
     * Creates a new LitRLIResource.
     * @param resource The identifier for the resource. This should be the
     * RLI token ID.
     */
    constructor(resource) {
        super(resource);
        this.resourcePrefix = models_1.LitResourcePrefix.RLI;
    }
    isValidLitAbility(litAbility) {
        return litAbility === models_1.LitAbility.RateLimitIncreaseAuth;
    }
}
exports.LitRLIResource = LitRLIResource;
class LitActionResource extends LitResourceBase {
    /**
     * Creates a new LitActionResource.
     * @param resource The identifier for the resource. This should be the
     * Lit Action IPFS CID.
     */
    constructor(resource) {
        super(resource);
        this.resourcePrefix = models_1.LitResourcePrefix.LitAction;
    }
    isValidLitAbility(litAbility) {
        return litAbility === models_1.LitAbility.LitActionExecution;
    }
}
exports.LitActionResource = LitActionResource;
function parseLitResource(resourceKey) {
    if (resourceKey.startsWith(models_1.LitResourcePrefix.AccessControlCondition)) {
        return new LitAccessControlConditionResource(resourceKey.substring(`${models_1.LitResourcePrefix.AccessControlCondition}://`.length));
    }
    else if (resourceKey.startsWith(models_1.LitResourcePrefix.PKP)) {
        return new LitPKPResource(resourceKey.substring(`${models_1.LitResourcePrefix.PKP}://`.length));
    }
    else if (resourceKey.startsWith(models_1.LitResourcePrefix.RLI)) {
        return new LitRLIResource(resourceKey.substring(`${models_1.LitResourcePrefix.RLI}://`.length));
    }
    else if (resourceKey.startsWith(models_1.LitResourcePrefix.LitAction)) {
        return new LitActionResource(resourceKey.substring(`${models_1.LitResourcePrefix.LitAction}://`.length));
    }
    throw new Error(`Invalid resource prefix: ${resourceKey}`);
}
exports.parseLitResource = parseLitResource;
//# sourceMappingURL=resources.js.map